import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainComponentWrapper from "../Common/MainComponentWrapper";

const EarningTicketListCommission = ({ isError, isLoading, details }) => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const tickets = details?.tickets || [];

  const openAttendees = (item) => {
    navigate("/organizer/myEarning/ticketType/attendeeList/commission", {
      state: {
        attendees: item?.attendees,
        eventId,
      },
    });
  };

  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      <div className="event-earning-detail-table-wrap">
        <table className="event-earning-detail-table">
          <thead>
            <tr>
              <th scope="col">Ticket Name</th>
              <th scope="col">Ticket Price</th>
              <th scope="col">Total Ticket commission</th>
              <th scope="col">Total Ticket Purchase</th>
            </tr>
          </thead>
          <tbody>
            {tickets.length > 0 ? (
              tickets.map((item, index) => (
                <tr
                  key={item?._id || index}
                  className="event-my-earnings-row"
                  style={{ cursor: "pointer" }}
                  onClick={() => openAttendees(item)}
                >
                  <td>
                    <button
                      type="button"
                      className="event-earning-detail-name-link"
                      onClick={(event) => {
                        event.stopPropagation();
                        openAttendees(item);
                      }}
                    >
                      {item?.name}
                    </button>
                  </td>
                  <td>USD {parseFloat(item?.price || 0).toFixed(2)}</td>
                  <td>
                    USD {parseFloat(item?.totalCommission || 0).toFixed(2)}
                  </td>
                  <td>
                    <button
                      type="button"
                      className="event-earning-detail-name-link"
                      onClick={(event) => {
                        event.stopPropagation();
                        openAttendees(item);
                      }}
                    >
                      {item?.soledTickets || 0}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4}>
                  <div className="event-earning-detail-not-found">
                    No tickets found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </MainComponentWrapper>
  );
};

export default EarningTicketListCommission;
